import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  fr: {
    translation: {
      brand: { tagline: "Connecter · Simplifier · Accompagner", developed_by: "Logiciel développé par" },
      auth: {
        title: "Se connecter",
        workspace: "Espace professionnel",
        welcome: "Bienvenue",
        connect_hint: "Connectez-vous avec votre code d'accès.",
        email: "Email",
        email_label: "Email professionnel",
        password: "Mot de passe",
        password_label: "Code d'accès",
        submit: "Se connecter",
        connecting: "Connexion…",
        quick_access: "Comptes de démonstration",
        unified: "Plateforme unifiée",
        pilot_head: "Pilotez vos",
        pilot_accent: "dossiers, réclamations & appels",
        pilot_tail: " — sans friction.",
        pilot_sub: "Traçabilité complète, workflow multi-service, IA d'analyse et tableau de bord temps réel pour vos équipes support et administration.",
        feat_dossiers: "Dossiers",
        feat_reclam: "Réclamations",
        feat_appels: "Appels",
        feat_ged: "GED & audit",
      },
      common: {
        loading: "Chargement…",
        save: "Enregistrer",
        cancel: "Annuler",
        edit: "Modifier",
        delete: "Supprimer",
        add: "Ajouter",
        search: "Rechercher",
        yes: "Oui",
        no: "Non",
        settings: "Paramètres",
        logout: "Déconnexion",
        language: "Langue",
        theme: "Thème",
        light: "Clair",
        dark: "Sombre",
        system: "Système",
        install_app: "Installer l'application",
        install_hint: "Ajoutez dkconnect à votre écran d'accueil pour un accès instantané et un usage hors ligne.",
        install: "Installer",
        later: "Plus tard",
        rights_reserved: "Tous droits réservés",
      },
      nav: {
        dashboard: "Tableau de bord",
        clients: "Clients",
        dossiers: "Dossiers",
        reclamations: "Réclamations",
        appels: "Appels",
        tickets: "File d'attente",
        ged: "Documents (GED)",
        kb: "Base de connaissances",
        chat: "Discussions",
        dm: "Messagerie",
        history: "Historique",
        users: "Utilisateurs",
        settings: "Paramètres",
        analytics: "Analytics",
        prospects: "Prospects",
      },
      borne: {
        header: "Borne — file d'attente",
        welcome_title: "Bienvenue chez {{company}}",
        welcome_subtitle: "Choisissez le service pour retirer votre ticket",
        display_link: "Écran d'affichage",
        info_title: "Vos informations",
        name: "Nom",
        phone: "Téléphone (optionnel)",
        get_ticket: "Obtenir mon ticket",
        back: "Retour",
        thanks: "Merci ! Votre ticket a bien été enregistré",
        hint: "Conservez votre numéro. Il sera appelé sur l'écran d'affichage.",
        your_number: "Votre numéro",
        position: "Position dans la file",
        service: "Service",
        new_ticket: "Prendre un autre ticket",
        print: "Imprimer",
      },
      display: {
        header: "Écran d'affichage — salle d'attente",
        now_serving: "En cours",
        next: "À suivre",
        upcoming: "Prochains",
        queue_empty: "Aucun ticket en attente",
      },
      settings: {
        title: "Paramètres de l'entreprise",
        identity: "Identité & marque",
        colors: "Palette de couleurs",
        services: "Services de la borne",
        messages: "Messages d'accueil (borne & écran)",
        primary_color: "Couleur principale",
        accent_color: "Couleur d'accent",
        secondary_color: "Couleur secondaire",
        queue_color: "Couleur file d'attente (borne / écran)",
        background_color: "Couleur d'arrière-plan",
        add_service: "Ajouter un service",
        service_label: "Libellé",
        service_key: "Clé interne",
        service_description: "Description",
        service_prefix: "Préfixe de ticket",
        service_enabled: "Activé",
        msg_welcome_title: "Titre d'accueil (borne)",
        msg_welcome_subtitle: "Sous-titre d'accueil (borne)",
        msg_ticket_thanks: "Message de confirmation ticket",
        msg_ticket_hint: "Astuce imprimée sur le ticket",
        msg_marquee: "Bandeau défilant (écran d'affichage)",
        msg_display_header: "Sous-titre écran d'affichage",
        msg_borne_header: "Sous-titre borne",
        placeholder_company: "Utilisez {company} pour insérer le nom de l'entreprise.",
      },
    },
  },
  en: {
    translation: {
      brand: { tagline: "Connect · Simplify · Support", developed_by: "Software developed by" },
      auth: {
        title: "Sign in",
        workspace: "Professional workspace",
        welcome: "Welcome back",
        connect_hint: "Sign in with your access code.",
        email: "Email",
        email_label: "Work email",
        password: "Password",
        password_label: "Access code",
        submit: "Sign in",
        connecting: "Signing in…",
        quick_access: "Demo accounts",
        unified: "Unified platform",
        pilot_head: "Manage your",
        pilot_accent: "cases, complaints & calls",
        pilot_tail: " — friction-free.",
        pilot_sub: "Full traceability, multi-service workflow, AI-powered analysis and a real-time dashboard for your support and admin teams.",
        feat_dossiers: "Cases",
        feat_reclam: "Complaints",
        feat_appels: "Calls",
        feat_ged: "DMS & audit",
      },
      common: {
        loading: "Loading…",
        save: "Save",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
        add: "Add",
        search: "Search",
        yes: "Yes",
        no: "No",
        settings: "Settings",
        logout: "Log out",
        language: "Language",
        theme: "Theme",
        light: "Light",
        dark: "Dark",
        system: "System",
        install_app: "Install the app",
        install_hint: "Add dkconnect to your home screen for instant access and offline use.",
        install: "Install",
        later: "Later",
        rights_reserved: "All rights reserved",
      },
      nav: {
        dashboard: "Dashboard",
        clients: "Clients",
        dossiers: "Cases",
        reclamations: "Complaints",
        appels: "Calls",
        tickets: "Queue",
        ged: "Documents (DMS)",
        kb: "Knowledge base",
        chat: "Discussions",
        dm: "Messages",
        history: "Audit log",
        users: "Users",
        settings: "Settings",
        analytics: "Analytics",
        prospects: "Prospects",
      },
      borne: {
        header: "Kiosk — queue",
        welcome_title: "Welcome to {{company}}",
        welcome_subtitle: "Choose a service to get your ticket",
        display_link: "Display screen",
        info_title: "Your details",
        name: "Full name",
        phone: "Phone (optional)",
        get_ticket: "Get my ticket",
        back: "Back",
        thanks: "Thanks! Your ticket has been registered",
        hint: "Keep your number. It will be called on the display screen.",
        your_number: "Your number",
        position: "Position in queue",
        service: "Service",
        new_ticket: "Take another ticket",
        print: "Print",
      },
      display: {
        header: "Display screen — waiting room",
        now_serving: "Now serving",
        next: "Next",
        upcoming: "Upcoming",
        queue_empty: "No tickets waiting",
      },
      settings: {
        title: "Company settings",
        identity: "Identity & brand",
        colors: "Color palette",
        services: "Kiosk services",
        messages: "Welcome messages (kiosk & display)",
        primary_color: "Primary color",
        accent_color: "Accent color",
        secondary_color: "Secondary color",
        queue_color: "Queue color (kiosk / display)",
        background_color: "Background color",
        add_service: "Add a service",
        service_label: "Label",
        service_key: "Internal key",
        service_description: "Description",
        service_prefix: "Ticket prefix",
        service_enabled: "Enabled",
        msg_welcome_title: "Welcome title (kiosk)",
        msg_welcome_subtitle: "Welcome subtitle (kiosk)",
        msg_ticket_thanks: "Ticket confirmation message",
        msg_ticket_hint: "Hint printed on the ticket",
        msg_marquee: "Scrolling banner (display screen)",
        msg_display_header: "Display screen subtitle",
        msg_borne_header: "Kiosk subtitle",
        placeholder_company: "Use {company} to insert the company name.",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "dkc-lang",
    },
  });

export default i18n;
